import React from 'react';
import styles from '../styles/Footer.module.css';

const Footer = () => {
  return (
    <footer className={styles.footer}>
      <div className={styles.left}></div>
      <div className={styles.right}>Built by Aditya Raj Kar</div>
    </footer>
  );
};

export default Footer;
